import {defineStore} from "pinia";
import {Ref, ref, computed} from "vue";
import {EventListener} from "@k/global/eventVerteiler";
import {StringDictionary} from "@k/js/delme_globals";
import {PalettenCluster} from "@k/js/databaseInterfaceClasses";


const palettenEventListener = new EventListener();
palettenEventListener.addEventListener("colorsInitializedEvent", () => {

})
const palettenClusters = ref({}) as Ref<StringDictionary<PalettenCluster>>;
const getPalette = (palettenName: string) => {

    for (const palettenClusterName in palettenClusters.value) {
        if (typeof (palettenClusters.value[palettenClusterName][palettenName]) !== "undefined") {
            return palettenClusters.value[palettenClusterName][palettenName];
        }
    }
    return null;
}

export const usePalettenClusterStore = defineStore("palettenCluster", () => {
    const getPalettenCluster = computed(() =>
        (palettenClusterName: string) => palettenClusters.value[palettenClusterName] || null);
    const setPalettenCluster =
        (palettenClustername: string, palettenCluster: PalettenCluster) => palettenClusters.value[palettenClustername] = palettenCluster;

    const clear = () => palettenClusters.value = {};

    return {
        setPalettenCluster,
        getPalettenCluster,
        clear,
        getPalette
    }

})